import { render, staticRenderFns } from "./CustomerSelectInputWidget.vue?vue&type=template&id=83d67faa&scoped=true"
import script from "./CustomerSelectInputWidget.vue?vue&type=script&lang=js"
export * from "./CustomerSelectInputWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83d67faa",
  null
  
)

export default component.exports